import DepositAddresses from './DepositAddresses';

export default DepositAddresses;
